import Model, { attr, belongsTo } from '@ember-data/model';
import type LedgerAccountModel from './ledger-account.ts';
import type LedgerEventModel from './ledger-event.ts';
import { Type } from '@warp-drive/core-types/symbols';
import type { LedgerProduct } from './ledger-account.ts';

export default class LedgerEntryModel extends Model {
  @attr declare creditAmount: number;
  @attr declare debitAmount: number;
  @attr declare entryDate: string;
  @attr declare itemType: string;
  @attr declare itemId: number;
  @attr declare metadata: Record<string, unknown> | null;
  @attr declare product: LedgerProduct;

  @belongsTo('ledger-account', { async: false, inverse: 'ledgerEntries' })
  declare ledgerAccount: LedgerAccountModel;

  @belongsTo('ledger-event', { async: false, inverse: 'ledgerEntries' })
  declare ledgerEvent: LedgerEventModel;

  [Type] = 'ledger-entry' as const;
}
